/**
 * Общие блоки посадочных страниц. Их делят между собой лендинги фулфилмента: страница
 * размещения карточки и страница заявки на просчёт. Данные каждая страница передаёт свои —
 * здесь только вёрстка и поведение.
 */
export { LandingAnchorNav, type LandingSection } from './anchor-nav'
export { LandingBenefits, type LandingBenefit } from './benefits'
export { LandingFaq, faqPageSchema, type LandingQuestion } from './faq'
export { LandingFigureRow, LandingFigureRowPlaceholder, type LandingFigure } from './figure-row'
export { LandingFinalCall, type LandingCallAction } from './final-call'
export { LandingCardRow, LandingCardStripe, LandingHero } from './hero'
export { LandingSteps, type LandingStep } from './steps'
export * as landingType from './typography'
